import { SearchBox } from "./InputBox";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <div className="top_panel">
      <Link to="/main">
        <div className="logo" />
      </Link>
      <div className="menu">
        <a>
          <div className="menu_block">關於</div>
        </a>
        <a>
          <div className="menu_block">賽程</div>
        </a>
        <div className="menu_item">
          <div className="menu_block">聯盟數據</div>
          <div className="menu_submenu">
            <ul>
              <li>
                <Link to="/umpire">
                  <div className="menu_subitem">裁判報告</div>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="menu_item">
          <div className="menu_block">成績排行榜</div>
          <div className="menu_submenu">
            <ul>
              <li>
                <Link to="/leaderboard">
                  <div className="menu_subitem">個人排行榜</div>
                </Link>
              </li>
              <li>
                <Link to="/team-leaderboard">
                  <div className="menu_subitem">團隊排行榜</div>
                </Link>
              </li>
              <li>
                <Link to="/discipline-leaderboard">
                  <div className="menu_subitem">紀律排行榜</div>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="menu_item">
          <div className="menu_block">成績統計</div>
          <div className="menu_submenu">
            <ul>
              <li>
                <Link to="/roster">
                  <div className="menu_subitem">個人成績</div>
                </Link>
              </li>
              <li>
                <Link to="/h2h-stat">
                  <div className="menu_subitem">對戰成績</div>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="menu_item">
          <div className="menu_block">團隊成績</div>
          <div className="menu_submenu">
            <ul>
              <li>
                <Link to="/catchers">
                  <div className="menu_subitem">捕手接補數據</div>
                </Link>
              </li>
              <li>
                <Link to="/game-report">
                  <div className="menu_subitem">單場報告</div>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <Link to="/filter">
          <div className="menu_block">篩選器</div>
        </Link>
        <div className="menu_item">
          <div className="menu_block">影音平台</div>
          <div className="menu_submenu">
            <ul>
              <li>
                <Link to="/video-list">
                  <div className="menu_subitem">影片列表</div>
                </Link>
              </li>
              <li>
                <Link to="/filmroom">
                  <div className="menu_subitem">影片篩選</div>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <SearchBox placeholder="搜尋選手" />
    </div>
  );
};

export default Header;
